import InquiryBadge from '@activities/customerService/InquiryActivity/components/InquiryLogs/InquiryBadge';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { InquiryResponse } from '@models/inquiry';
import dayjs from 'dayjs';

interface Props {
    inquiry: InquiryResponse;
}

/** 문의 상태·작성일·제목·본문 */
function InquiryHeader({ inquiry }:Props) {
    const {
        status, title, content, createdAt, fileUrls,
    } = inquiry;
    return (
        <Container as='section' fullWidth spacing={4}>
            <Row spacing={2}>
                <InquiryBadge status={status}/>
                <Text color={colors.textSecondary}>
                    {dayjs(createdAt).format('YYYY.MM.DD HH:mm')}
                </Text>
            </Row>
            <Column fullWidth spacing={2}>
                <BreakText size='headline' fontWeight='bold' color={colors.textPrimary}>
                    {title}
                </BreakText>
                <BreakText color={colors.textPrimary}>{content}</BreakText>
            </Column>
            {(fileUrls && fileUrls.length !== 0) && (
                <Images>
                    {fileUrls.map((fileUrl) => (
                        <Image src={fileUrl}
                            key={fileUrl} />
                    ))}
                </Images>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    background-color: var(--color-background-pure);
    padding: var(--spacing-4);
`;

const BreakText = styled(Text)`
    white-space: pre-wrap;
    word-break: break-word;
`;

const Images = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3);
    width: 100%;

    img {
        max-width: 100%;
    }
`;

export default InquiryHeader;
